// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import { makeServiceRequest } from '../ServiceRequest';
import type RequestOptions from '../RequestOptions';
import type GetMailboxPermissionRequest from '../contract/GetMailboxPermissionRequest';
import type GetMailboxPermissionResponse from '../contract/GetMailboxPermissionResponse';
import getMailboxPermissionRequest from '../factory/getMailboxPermissionRequest';

export default function getMailboxPermissionOperation(
    req: GetMailboxPermissionRequest,
    options?: RequestOptions
): Promise<GetMailboxPermissionResponse> {
    if (req !== undefined && !req['__type']) {
        req = getMailboxPermissionRequest(req);
    }

    return makeServiceRequest<GetMailboxPermissionResponse>('GetMailboxPermission', req, options);
}
